import {
    Component,
    InputSignal,
    input, ChangeDetectionStrategy
} from "@angular/core";
import {DisplayableOrderItem} from '../order';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {CurrencyPipe} from '../../utils/currency.pipe';

/**
 * Display the details of extras for an order item
 */
@Component({
    selector: "woa-order-extras-panel",
    templateUrl: "order-extras-panel.component.html",
    styleUrl: "./order-extras-panel.component.scss",
    imports: [
        CurrencyPipe,
        NgClass,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderExtrasPanelComponent {
    public readonly item: InputSignal<DisplayableOrderItem> = input.required<DisplayableOrderItem>();

    public readonly showTotal: InputSignal<boolean> = input<boolean>(false);
}
